<form [formGroup]="form">

  <!-- ============================================================ -->
  <!-- SECTION 1: CHOOSE A CHARITY (hidden for Charity Admin) -->
  <!-- ============================================================ -->
  <div class="form-section">
    <div class="section-header">
      <span class="section-number">1</span>
      <span class="section-title">{{ 'add.charity.form.section1' | translateLang }}</span>
    </div>

    <div class="two-column-row">
      <div class="field-group">
        <app-text-input
          formControlName="charityName"
          [label]="'add.charity.form.charity_name.label' | translateLang"
          [placeholder]="'add.charity.form.charity_name.placeholder' | translateLang"
          [required]="true"
          [helperText]="'grant.form.required_field' | translateLang"
          [errorMessages]="{
            required: 'add.charity.error.required.charity_name' | translateLang,
            minLength: 'add.charity.error.min_length.charity_name' | translateLang,
            maxLength: 'add.charity.error.max_length.charity_name' | translateLang,
            lettersNumbersCharacters: 'add.charity.error.characters.charity_name' | translateLang
          }"
        />
      </div>

      @if (!isSinngeber) {
        <div class="field-group">
          <app-text-input
            formControlName="registrationNumber"
            [label]="'add.charity.form.registration_number.label' | translateLang"
            [placeholder]="'add.charity.form.registration_number.placeholder' | translateLang"
            [required]="isCncf"
            [errorMessages]="{
              required: 'add.charity.error.required.registration_number' | translateLang
            }"
          />
        </div>
      }
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- SECTION 2: ANTICIPATED GRANT AMOUNT -->
  <!-- ============================================================ -->
  <div class="form-section">
    <div class="section-header">
      <span class="section-number">2</span>
      <span class="section-title">{{ 'add.charity.form.section2' | translateLang }}</span>
    </div>

    <app-amount-currency-input
      formControlName="amountCurrency"
      [currencySets]="availableCurrencies"
      [required]="true"
      [currencyDisabled]="currencyDisabled"
    />
  </div>

  <!-- ============================================================ -->
  <!-- SECTION 3: ENTER DETAILS -->
  <!-- ============================================================ -->
  <div class="form-section">
    <div class="section-header">
      <span class="section-number">3</span>
      <span class="section-title">{{ 'add.charity.form.section3' | translateLang }}</span>
    </div>

    <div class="field-group">
      <app-country-selector
        formControlName="country"
        [countries]="countries"
        [label]="'add.charity.form.country.label' | translateLang"
        [placeholder]="'add.charity.form.country.placeholder' | translateLang"
        [errorMessage]="'add.charity.error.required.country' | translateLang"
        [required]="true"
        [helperText]="'grant.form.required_field' | translateLang"
      />
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- SECTION 4: GIVER INFORMATION -->
  <!-- ============================================================ -->
  <div class="form-section">
    <div class="section-header">
      <span class="section-number">4</span>
      <span class="section-title">{{ 'add.charity.form.section4' | translateLang }}</span>
    </div>

    <div class="three-column-row">
      <div class="field-group">
        <app-text-input
          formControlName="contactName"
          [label]="'add.charity.form.contact_name.label' | translateLang"
          [placeholder]="'add.charity.form.contact_name.placeholder' | translateLang"
          [required]="true"
          [errorMessages]="{
            required: 'add.charity.error.required.contact_name' | translateLang,
            minLength: 'add.charity.error.min_length.contact_name' | translateLang,
            maxLength: 'add.charity.error.max_length.contact_name' | translateLang,
            lettersNumbersCharacters: 'add.charity.error.characters.contact_name' | translateLang
          }"
        />
      </div>
      <div class="field-group">
        <app-text-input
          formControlName="contactEmail"
          [label]="'add.charity.form.contact_email.label' | translateLang"
          [placeholder]="'add.charity.form.contact_email.placeholder' | translateLang"
          [required]="true"
          inputType="email"
          [errorMessages]="{
            required: 'add.charity.error.required.contact_email' | translateLang,
            email: 'add.charity.error.invalid.contact_email' | translateLang
          }"
        />
      </div>
      <div class="field-group">
        <app-text-input
          formControlName="contactPhone"
          [label]="'add.charity.form.contact_phone.label' | translateLang"
          [placeholder]="'add.charity.form.contact_phone.placeholder' | translateLang"
          [required]="true"
          [errorMessages]="{
            required: 'add.charity.error.required.contact_phone' | translateLang,
            phone: 'add.charity.error.invalid.contact_phone' | translateLang
          }"
        />
      </div>
    </div>

    <div class="field-group">
      <app-text-input
        formControlName="charityAddress"
        [label]="'add.charity.form.address.label' | translateLang"
        [placeholder]="'add.charity.form.address.placeholder' | translateLang"
      />
    </div>

    <div class="field-group">
      <app-text-input
        formControlName="comments"
        [label]="'add.charity.form.comments.label' | translateLang"
        [placeholder]="'add.charity.form.comments.placeholder' | translateLang"
        inputType="textarea"
        [maxlength]="250"
        [showCharacterCount]="true"
        [errorMessages]="{
          maxLength: 'add.charity.error.max_length.comments' | translateLang
        }"
      />
    </div>
  </div>

</form>
